import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import { AuthProvider } from './contexts/authContext'

import ForgotPassword from './views/pages/forgotPassword/forgotPassword'
import ChangePassword from './views/pages/changePassword/changePassword'
import { ALTERAR_SENHA, ESQUECI_MINHA_SENHA, LOGIN } from './shared/pathRoutes'
import { ToastsProvider } from './contexts/toastContext'
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <ToastsProvider>
          <AuthProvider>
            <Suspense fallback={loading}>
              <Routes>
                <Route exact path={LOGIN} name="Login" element={<Login />} />
                <Route
                  exact
                  path={ESQUECI_MINHA_SENHA}
                  name="Forgot Password"
                  element={<ForgotPassword />}
                />
                <Route
                  exact
                  path={ALTERAR_SENHA}
                  name="Change Password"
                  element={<ChangePassword />}
                />
                <Route exact path="/404" name="Page 404" element={<Page404 />} />
                <Route exact path="/500" name="Page 500" element={<Page500 />} />
                <Route path="*" name="Home" element={<DefaultLayout />} />
              </Routes>
            </Suspense>
          </AuthProvider>
        </ToastsProvider>
      </BrowserRouter>
    )
  }
}

export default App
